import * as Types from './types'
export const FILTER_STATUS_ALL: Types.Filter = {
  description: 'Show all records',
  key: 'status',
  value: 'all',
}
export const FILTER_STATUS_ACTIVE: Types.Filter = {
  description: 'Only show active records',
  key: 'status',
  value: 'active',
}
export const FILTER_STATUS_INACTIVE: Types.Filter = {
  description: 'Only show inactive records',
  key: 'status',
  value: 'inactive',
}

export const StatusFilterParameters: Types.Filter[] = [
  FILTER_STATUS_ALL, FILTER_STATUS_ACTIVE, FILTER_STATUS_INACTIVE ]

export const UPDATE_SELECTED_DATE = 'UPDATE_SELECTED_DATE'



// WEBPACK FOOTER //
// ./src/components/is_active/constants.ts